import type { TelemetryRuntime } from "../../core/types.js";
import type { SentryLike } from "./types.js";

/**
 * Per-telemetry-handle registry for injected or dynamically loaded Sentry SDK clients.
 */
export class SentryClientRegistry {
  readonly #registered: Record<TelemetryRuntime, SentryLike | null> = {
    client: null,
    server: null,
  };
  readonly #loaded: Record<TelemetryRuntime, SentryLike | null> = {
    client: null,
    server: null,
  };

  register(client: SentryLike, runtime: TelemetryRuntime = "client"): () => void {
    this.#registered[runtime] = client;
    this.#loaded[runtime] = client;
    return () => {
      this.#registered[runtime] = null;
      this.#loaded[runtime] = null;
    };
  }

  getRegistered(runtime: TelemetryRuntime): SentryLike | null {
    return this.#registered[runtime];
  }

  getLoaded(runtime: TelemetryRuntime): SentryLike | null {
    return this.#loaded[runtime];
  }

  setLoaded(runtime: TelemetryRuntime, client: SentryLike): void {
    this.#loaded[runtime] = client;
  }
}
